import { Link } from 'react-router-dom';
import styles from './css/Style.module.css';
import { IconYoutube } from '../Icons';
import { LINKS_INSTAGRAM, LINKS_LINKEDIN, LINKS_WHATSAPP, LINKS_YOUTUBE } from '../../Links';
function FooterSimples({ allowAvalie = false }) {
    return (
        <>
            {allowAvalie &&
                <Link to={'/avaliacao/'} className={`${styles.avalie}`} >
                    <i className={`${styles.icon_avalie} ${styles.icon_avaliar}`}>&nbsp;</i>
                    <p>Avalie a sua experiência<br /><b>Conte o que está achando do App TooMe!</b></p>
                    <b className={`${styles.icon_avalie} ${styles.icon_angle_right_red} ${styles.jogar_direita} icon_angle_right_red`}>&nbsp;</b>
                </Link>
            }
            <footer className={`${styles.footer_unions}`}>
                <hr className={`${styles.linha_hr2}`} /><br />
                <p>&copy; 2024-2025 Union's.<br />Todos os direitos reservados.</p><br />
                <div className={`${styles.final_icons}`}>
                    <a target="_blank" href={LINKS_INSTAGRAM} aria-label='Instagram TooMe' className={`${styles.icon} ${styles.icon_instagram}`}>&nbsp;</a>
                    <a target="_blank" href={LINKS_LINKEDIN} aria-label='Linkedin TooMe' className={`${styles.icon} ${styles.icon_linkedin}`}>&nbsp;</a>
                    <a href={LINKS_WHATSAPP} aria-label='Whatsapp TooMe' className={`${styles.icon} ${styles.icon_whatsapp}`} target="_blank">&nbsp;</a>
                    <a target="_blank" href={LINKS_YOUTUBE} aria-label='Youtube TooMe'><IconYoutube color='var(--cor_tooMe)' size='22' /></a>
                </div>
                <br />
                <hr className={`${styles.hr_final}`}></hr>
            </footer>
        </>

    );
}

export default FooterSimples;